
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'; // Use Routes instead of Switch
import HomeComponent from './components/HomeComponent';
import AboutUs from './components/AboutUs';
import RegisterForm from './components/RegisterForm';
import Site from './components/Site';
import RegistrationPage from './components/RegisterForm';
import OnboardingForm from './components/OnboardingForm';
import SearchLocationInput from './components/SearchLocationInput';
import MapComponent from './components/MapComponent';
import PrivacyPolicy from './components/PrivacyPolicy';

const AppRoutes = () => {
  return (
    <BrowserRouter>
    <Routes>
      {/* Define your routes here */}
      <Route path="/" element={<Site />} >
        <Route path="/" element={<HomeComponent />} />
        <Route path='/register' element={<RegistrationPage />} />
        <Route path='/onboarding' element={<OnboardingForm/>} />
        <Route path='/searchlocation' element={< SearchLocationInput/>} />
        <Route path='/map' element={< MapComponent/>} />
        <Route path='privacy-policy' element={< PrivacyPolicy />}/>

        {/* Catch-all route for 404, redirect to home page */}
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
